export const parseUnixTimestamp = (timeStamp) => new Date(timeStamp * 1000);
